import { render, staticRenderFns } from "./comp_BookEditorCustomizationInputs-primeraComunion.vue?vue&type=template&id=aa1e4856&scoped=true&"
import script from "./comp_BookEditorCustomizationInputs-primeraComunion.vue?vue&type=script&lang=js&"
export * from "./comp_BookEditorCustomizationInputs-primeraComunion.vue?vue&type=script&lang=js&"
import style0 from "./comp_BookEditorCustomizationInputs-primeraComunion.vue?vue&type=style&index=0&id=aa1e4856&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1e4856",
  null
  
)

export default component.exports